// extracted by mini-css-extract-plugin
export default {"tooltip":"EU-z","arrow":"FU-z"};